import HandleDecrement from "./Handle_decrement";

const decrement_server_side = async (
  e,
  user,
  userInfo,
  item,
  handleAlert,
  setGif,
  decrease_item
) => {
  setGif(true);

  e.preventDefault();
  let response = await HandleDecrement({
    userInfo,
    user,
    item,
    decrease_item,
  });
  if (response) {
    setGif(false);
    handleAlert({
      show: true,
      type: "success",
      text: "Quantity decreased with success",
    });
  } else {
    setGif(false);
    handleAlert({
      show: true,
      type: "error",
      text: "Something went wrong please try again....",
    });
  }
};

export { decrement_server_side as default };
